import classNames from "classnames";
import { IDotsButtonProps } from "dots-ui/dotsButton";
import { AvisPrimaryButton } from "./AvisPrimaryButton";

export function AvisConfirmButton(props: Readonly<IDotsButtonProps>) {
  const { className, ...restProps } = props;

  const classNameCombined = classNames("confirm-button", className);
  return <AvisPrimaryButton className={classNameCombined} {...restProps} />;
}
